module.exports = __webpack_public_path__ + "img/activity.afd1e1f5.svg";